module.exports = __webpack_public_path__ + "img/20.00ab6682.svg";